import classNames from 'classnames';
import queryString from 'query-string';
import { t, c } from 'ttag';

import FacebookIcon from '@svg/facebook-colorless.svg';
import XIcon from '@svg/x.svg';
import { useRegion } from '@hook/useRegion';
import { Button } from '@ui/Button';

import s from './ProductDetailsSocialsShare.sss';

const SHARE_WINDOW_WIDTH = 500;
const SHARE_WINDOW_HEIGHT = 300;
const FACEBOOK_SHARE_URL = 'https://www.facebook.com/sharer/sharer.php';
const TWITTER_SHARE_URL = 'https://twitter.com/intent/tweet/';

interface Props {
  className?: string,
  productName: string,
  brandName?: string | null,
  price?: number | null,
}

export const ProductDetailsSocialsShare: React.FC<Props> = ({
  className,
  productName,
  brandName,
  price,
}) => {
  const { currencyName } = useRegion();

  let postTitle = productName;

  if (brandName) {
    postTitle = `${productName} ${brandName}`;
  }

  if (price) {
    postTitle = c('socialShare').t`${postTitle} за ${price} ${currencyName}`;
  }

  const getFacebookShareUrl = () => {
    const searchParams = queryString.stringify({
      u: window.location.href,
      title: postTitle,
    });

    return `${FACEBOOK_SHARE_URL}?${searchParams}`;
  };

  const getTwitterShareUrl = () => {
    const searchParams = queryString.stringify({
      url: window.location.href,
      text: postTitle,
    });

    return `${TWITTER_SHARE_URL}?${searchParams}`;
  };

  const handleShare = (url: string) => {
    const left = (window.screen.width / 2) - (SHARE_WINDOW_WIDTH / 2);
    const top = (window.screen.height / 2) - (SHARE_WINDOW_HEIGHT / 2);

    window.open(url, '', `menubar=no,toolbar=no,resizable=yes,scrollbars=yes,width=${SHARE_WINDOW_WIDTH},height=${SHARE_WINDOW_HEIGHT},top=${top},left=${left}`);
  };

  return (
    <div className={classNames(s.root, className)}>
      <p className={s.title}>
        {t`Поділитися:`}
      </p>

      <ul className={s.list}>
        <li>
          <Button
            theme='text'
            onClick={() => handleShare(getFacebookShareUrl())}
          >
            <FacebookIcon
              className={s.icon}
              width='16'
              height='16'
            />
          </Button>
        </li>
        <li>
          <Button
            theme='text'
            onClick={() => handleShare(getTwitterShareUrl())}
          >
            <XIcon
              className={s.icon}
              width='16'
              height='16'
            />
          </Button>
        </li>
      </ul>
    </div>
  );
};
